module.exports = __webpack_public_path__ + "img/banner_8.f8cf6141.jpg";